import { CircleAlert, CircleCheck, Info, type LucideIcon } from "lucide-react";
import type { ToastSentiment } from "./types";

/** Card background + border per sentiment. */
export const CARD_SENTIMENT_CLASS: Record<ToastSentiment, string> = {
  default: "bg-fill-panel-neutral border-border-panel-neutral",
  negative: "bg-fill-panel-negative border-border-panel-negative",
  positive: "bg-fill-panel-positive border-border-panel-positive",
  emphasis: "bg-fill-bg-emphasis border-border-panel-emphasis",
};

/** Action-button border per sentiment; the button text stays neutral in every sentiment. */
export const ACTION_BORDER_CLASS: Record<ToastSentiment, string> = {
  default: "border-border-action-neutral-idle",
  negative: "border-border-action-negative-idle",
  positive: "border-border-tag-positive-idle",
  emphasis: "border-border-tag-emphasis-idle",
};

/** Default leading icon per sentiment; overridable via the `icon` prop. */
export const DEFAULT_SENTIMENT_ICON: Record<ToastSentiment, LucideIcon> = {
  default: Info,
  negative: CircleAlert,
  positive: CircleCheck,
  emphasis: Info,
};
